import gql from 'graphql-tag';
export const getUsersConfigurationCompany = gql`
query getUsersConfigurationCompany {
        getUsersConfigurationCompany {
            signMail
  }
}
`;

export const getSignMail = gql`
query getUsersConfigurationCompany {
        getUsersConfigurationCompany {
            signMail
  }
}
`;
